/**
 * Paramètres des frais cartes
 *
 * @author Guillaume TRAVOT
 * @date 12/02/2026
 */
export class ParamsCartes {
    antiDoublonInterLot: boolean;
    antiDoublonIntraLot: boolean;
    antiDoublonIntraFichier: boolean;
    depPersoCollab: boolean;
    depPersoAssistant: boolean;
    retraitDAB: boolean;

    constructor(dto?: any) {
        if (dto) {
            this.antiDoublonInterLot = dto.antiDoublonInterLot;
            this.antiDoublonIntraLot = dto.antiDoublonIntraLot;
            this.antiDoublonIntraFichier = dto.antiDoublonIntraFichier;
            this.depPersoCollab = dto.depPersoCollab;
            this.depPersoAssistant = dto.depPersoAssistant;
            this.retraitDAB = dto.retraitDAB;
        }
    }
}